import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { IFileStoreItem } from '../../../../documents/interfaces/IFileStoreItem';
import { IFileInfo } from '../../../../directives/file-drop/interfaces/IFileInfo';

@Component({
  selector: 'app-drop-file',
  templateUrl: './drop-file.component.html',
  styleUrls: ['./drop-file.component.css']
})
export class DropFileComponent implements OnInit {
  fileInfo:IFileStoreItem = null;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: IFileInfo,
    public dialogRef: MatDialogRef<DropFileComponent>
    ) { }

  ngOnInit() {
    console.log('DropFileComponent',this.data);
  }
  onUpload(file:IFileStoreItem){
    console.log('onUpload',file);
    this.dialogRef.close(file);
  }

}
